// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"c006ebae","774":"2aea7a12","915":"13b89759","943":"054de4f4","979":"ccff55fc"}[chunkId] + ".chunk.js";
};